<parkour-button
  (clicked)="downloadAfspraken()"
  class="w-full"
  iconAfter="download"
  variant="tertiary"
>
  Afspraken downloaden
</parkour-button>
